<template>
  <v-container id="caracteristicas" tag="section">
    <base-v-component heading="Características del Sistema" />
    <base-material-card
      color="indigo"
      icon="mdi-basket"
      inline
      class="px-5 py-3"
    >
      <v-toolbar flat color="white">
        <v-btn color="success" dark class="mb-2" @click.stop="showDialog()">{{
          formTitle
        }}</v-btn>
        <v-btn
          v-if="isAdmin"
          :loading="loadingTraducir"
          color="secondary"
          dark
          outlined
          small
          class="mb-2 mx-4"
          @click="traducirLoQueSeVe()"
          >Traducir lo que se ve
          <v-icon class="ml-1" small>mdi-google-translate</v-icon></v-btn
        >
        <v-btn
          v-if="!ordenando"
          color="success"
          dark
          class="mx-2 mb-2"
          @click="ordenando = true"
          >Ordenar</v-btn
        >
        <v-btn
          v-if="ordenando"
          color="success"
          dark
          class="mx-2 mb-2"
          @click="ordenando = false"
          >Volver listado</v-btn
        >
        <v-spacer />
        <v-select
          :items="gruposCaracteristicas"
          v-model="caracteristicasFiltrando"
        ></v-select>
        <v-spacer />
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          label="Buscar"
          single-line
          hide-details
        ></v-text-field>
        <v-spacer></v-spacer>
        <v-btn color="success" @click="reload()">
          <v-icon color="white">mdi-autorenew</v-icon>
        </v-btn>

        <v-dialog v-model="dialog" max-width="500px">
          <v-card>
            <v-card-title>
              <span class="headline">{{ formTitle }}</span>
            </v-card-title>
            <v-card-text>
              <v-container grid-list-md>
                <v-select
                  :items="idiomas"
                  v-model="langSeleccionado"
                  label="Selección idioma"
                  outlined
                ></v-select>
                <template v-for="lang in idiomas">
                  <v-layout
                    wrap
                    :key="lang.value"
                    v-if="lang.value == langSeleccionado"
                  >
                    <v-flex xs12 sm12>
                      <h4>IDIOMA {{ lang.text }}</h4>
                    </v-flex>

                    <v-flex xs12 sm6>
                      <v-text-field
                        v-model="nombreShow"
                        label="Nombre"
                        :error-messages="nombreErrors"
                        @input="$v.nombreValidar.$touch()"
                        @blur="$v.nombreValidar.$touch()"
                        ref="nombreReferencia"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-select
                        v-model="grupo"
                        :items="gruposCaracteristicas"
                        label="Grupo Característica"
                        :error-messages="grupoErrors"
                        @input="$v.grupo.$touch()"
                        @blur="$v.grupo.$touch()"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 sm12>
                      <v-text-field
                        v-model="descripcionShow"
                        label="Descripcion"
                        :error-messages="descripcionErrors"
                        @input="$v.descripcionValidar.$touch()"
                        @blur="$v.descripcionValidar.$touch()"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 sm6>
                      <v-file-input
                        v-if="!imagenSrc"
                        accept="image/*"
                        label="Imagen"
                        v-model="imagen"
                      ></v-file-input>
                      <v-img v-else :src="imagenSrc" width="65px"></v-img>
                    </v-flex>
                  </v-layout>
                </template>
              </v-container>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="blue darken-1" text @click="close">Cancelar</v-btn>
              <v-btn
                color="blue darken-1"
                text
                @click="save"
                :loading="loadingForm"
                >Guardar</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-toolbar>
      <v-data-table
        :headers="headers"
        :items="caracteristicasFiltradas"
        :loading="loading"
        :search="search"
        sortBy="orden"
        disable-pagination
        v-if="!ordenando"
      >
        <template v-slot:item.imagen="{ item }">
          <v-img
            v-if="item.imagen"
            :src="item.imagen"
            aspect-ratio="1"
            width="35px"
          ></v-img>
          <span v-else>sin imagen</span>
        </template>
        <template v-slot:item.nombre="{ item }">{{
          mostrarIdioma(item.nombre)
        }}</template>
        <template v-slot:item.descripcion="{ item }">{{
          mostrarIdioma(item.descripcion)
        }}</template>
        <template v-slot:item.acciones="{ item }">
          <v-card-actions class="pa-0 ma-0">
            <v-spacer></v-spacer>
            <v-btn class="px-2 ml-1" color="success" min-width="0" small>
              <v-icon small @click="editItem(item)">mdi-pencil</v-icon>
            </v-btn>
            <v-btn class="px-2 ml-1" color="red" min-width="0" small>
              <v-icon small @click="deleteItem(item)">mdi-delete</v-icon>
            </v-btn>
          </v-card-actions>
        </template>
      </v-data-table>
      <v-row v-else align="center" justify="center">
        <v-col cols="6">
          <v-list>
            <draggable v-model="ordenC">
              <div v-for="element in caracteristicasOrden" :key="element.id">
                <v-list-item>
                  <v-list-item-avatar>
                    <v-icon big>mdi-drag</v-icon>
                  </v-list-item-avatar>
                  <v-list-item-content>{{
                    mostrarIdioma(element.nombre)
                  }}</v-list-item-content>
                  <v-list-item-action>{{ element.orden }}</v-list-item-action>
                </v-list-item>
              </div>
            </draggable>
          </v-list>
        </v-col>
      </v-row>
    </base-material-card>
  </v-container>
</template>

<script>
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import { mapState, mapGetters } from "vuex";
import draggable from "vuedraggable";
import { mostrarIdioma } from "@/utils/utils.js";
export default {
  mixins: [validationMixin],
  components: {
    draggable,
  },
  validations: {
    nombreValidar: { required },
    descripcionValidar: { minLength: minLength(4) },
    grupo: { required },
  },
  data() {
    return {
      loadingTraducir: false,
      id: null,
      nombreIdiomas: null,
      nombreValidar: "",
      descripcionIdiomas: null,
      descripcionValidar: "",
      imagen: null,
      imagenSrc: null,
      grupo: null,
      search: "",
      ordenando: false,
      loading: false,
      loadingForm: false,
      dialog: false,
      headers: [
        {
          sortable: true,
          text: "Orden",
          value: "orden",
          width: "90",
        },
        {
          sortable: false,
          text: "Imagen",
          value: "imagen",
        },
        {
          sortable: false,
          text: "Nombre",
          value: "nombre",
        },
        {
          sortable: false,
          text: "Descripción",
          value: "descripcion",
        },
        {
          sortable: false,
          text: "Acciones",
          value: "acciones",
          align: "right",
        },
      ],
      caracteristicasFiltrando: null,
    };
  },
  computed: {
    nombreErrors() {
      const errors = [];
      if (!this.$v.nombreValidar.$dirty) return errors;
      !this.$v.nombreValidar.required &&
        errors.push("Nombre idioma por defecto obligatorio.");
      return errors;
    },
    descripcionErrors() {
      const errors = [];
      if (!this.$v.descripcionValidar.$dirty) return errors;
      !this.$v.descripcionValidar.minLength &&
        errors.push("Descripción idioma por defecto demasiado corto.");
      return errors;
    },
    grupoErrors() {
      const errors = [];
      if (!this.$v.grupo.$dirty) return errors;
      !this.$v.grupo.required && errors.push("Grupo requerido");
      return errors;
    },
    ...mapGetters({
      isAdmin: "auth/isAdmin",

      negocio: "app/negocioGestObj",
    }),
    ...mapState({
      caracteristicas: (state) => state.caracteristicas.caracteristicasArray,
      gruposCaracteristicas: (state) =>
        state.caracteristicas.grupoCaracteristicas,
      idiomas: "idiomas",
      langDefecto: "langDefecto",
    }),
    langSeleccionado: {
      get() {
        return this.$store.state.langSeleccionado;
      },
      set(v) {
        this.$store.commit("setLangSeleccionado", v);
      },
    },
    formTitle() {
      return this.isEdit ? "Editar Característica" : "Nueva Característica";
    },
    accion() {
      return this.id ? "edit" : "add";
    },
    isAdd() {
      return this.accion == "add";
    },
    isEdit() {
      return this.accion == "edit";
    },
    nombreShow: {
      get() {
        let _vm = this;
        var found = this.nombreIdiomas.find(
          (e) => e.lang == _vm.langSeleccionado
        );
        return found ? found.text : "";
      },
      set(v) {
        let _vm = this;
        var index = this.nombreIdiomas.findIndex(
          (e) => e.lang == _vm.langSeleccionado
        );
        var defecto = this.nombreIdiomas.find((e) => e.lang == _vm.langDefecto);
        this.nombreValidar = defecto.text;
        this.nombreIdiomas[index].text = v;
      },
    },
    descripcionShow: {
      get() {
        let _vm = this;
        var found = this.descripcionIdiomas.find(
          (e) => e.lang == _vm.langSeleccionado
        );
        return found ? found.text : "";
      },
      set(v) {
        let _vm = this;
        var index = this.descripcionIdiomas.findIndex(
          (e) => e.lang == _vm.langSeleccionado
        );
        var defecto = this.descripcionIdiomas.find(
          (e) => e.lang == _vm.langDefecto
        );
        this.descripcionValidar = defecto.text;
        this.descripcionIdiomas[index].text = v;
      },
    },
    caracteristicasFiltradas() {
      return this.caracteristicas.filter(
        (e) => e.grupo == this.caracteristicasFiltrando
      );
    },
    caracteristicasOrden() {
      return this.caracteristicasFiltradas.sort((a, b) =>
        a.orden > b.orden ? 1 : b.orden > a.orden ? -1 : 0
      );
    },
    ordenC: {
      get() {
        return this.caracteristicasOrden;
      },
      set(v) {
        var res = [];
        let _vm = this;
        v.forEach((e, i) => {
          let aux = {
            orden: i,
            id: e.id,
          };
          res.push(aux);
        });
        return this.$store
          .dispatch("caracteristicas/ordenarCaracteristicas", res)
          .then(() => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Características ordenadas",
            });
            _vm.getCaracteristicas();
          })
          .catch((e) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al ordenar características",
            });
            console.log(e);
          });
      },
    },
  },
  watch: {
    dialog(val) {
      val || this.close();
    },
  },
  methods: {
    traducirLoQueSeVe() {
      this.loadingTraducir = true;
      let traducir = this.caracteristicas
        .map((prd) => {
          return [
            {
              id: prd.id,
              key: "nombre",
              texto: prd.nombre,
            },
            {
              id: prd.id,
              key: "descripcion",
              texto: prd.descripcion,
            },
          ];
        })
        .flat();
      this.$store
        .dispatch("traducir", traducir)
        .then((r) => {
          console.log(_.groupBy(r, "id"));
          let agrupados = _.groupBy(r, "id");
          var promesas = [];
          for (let prop in agrupados) {
            let propDinamicas = {};
            agrupados[prop].forEach((p) => {
              propDinamicas[p.key] = p.texto;
            });
            console.log(agrupados);
            let objGuardar = {
              id: prop,
              ...propDinamicas,
            };
            console.log(objGuardar);
            // return Promise.resolve();
            promesas.push(
              this.$store
                .dispatch("caracteristicas/addCaracteristica", {
                  ...objGuardar,
                })
                .catch((e) => console.log(e))
            );
          }
          return Promise.all(promesas);
        })
        .finally(() => {
          this.getCaracteristicas();
          this.loadingTraducir = false;
        });
    },
    reload() {
      this.getCaracteristicas();
    },
    mostrarIdioma(s) {
      return mostrarIdioma(s);
    },
    mostrarGrupo(gr) {
      let res = "";
      let grupo_a = this.gruposCaracteristicas;
      let found = grupo_a.find((e) => e.value == gr);
      if (found) res = found.text;
      return res;
    },
    showDialog() {
      this.dialog = true;
      //this.$nextTick(this.$refs.nombreReferencia.focus())
    },
    editItem(item) {
      this.nombreIdiomas = JSON.parse(JSON.stringify(item.nombre));
      this.nombreShow = this.nombreShow;
      this.descripcionIdiomas = JSON.parse(JSON.stringify(item.descripcion));
      this.descripcionShow = this.descripcionShow;
      this.grupo = item.grupo;
      this.imagenSrc = item.imagen;
      this.showDialog();
      this.id = item.id;
    },
    deleteItem(item) {
      let r = confirm("¿Quieres eliminar la categoría? (no se puede deshacer)");
      if (r) {
        this.loading = true;
        let _vm = this;
        this.$store
          .dispatch("caracteristicas/deleteCaracteristica", item)
          .then((res) => {
            _vm.$store.commit("snackbar/setMensajeSuccess", {
              msj: "Característica eliminada",
            });
            _vm.getCaracteristicas();
          })
          .catch((error) => {
            _vm.$store.commit("snackbar/setMensajeDanger", {
              msj: "Error al eliminar",
            });
          })
          .finally(() => {
            this.loading = false;
          });
      }
    },
    getCaracteristicas() {
      this.loading = true;
      let _vm = this;
      return this.$store
        .dispatch("caracteristicas/getCaracteristicas")
        .finally(() => {
          _vm.loading = false;
        });
    },
    close() {
      this.dialog = false;
      this.$v.$reset();
      let _vm = this;
      setTimeout(() => {
        _vm.reiniciarDatos();
      }, 300);
    },
    reiniciarDatos() {
      let a_nombre = [];
      let a_descripcion = [];
      for (var lang of this.idiomas) {
        let aux_1 = { lang: lang.value, text: "" };
        let aux_2 = { lang: lang.value, text: "" };
        a_nombre.push(aux_1);
        a_descripcion.push(aux_2);
      }
      this.id = null;
      this.nombreIdiomas = a_nombre;
      this.descripcionIdiomas = a_descripcion;
      this.imagenSrc = null;
      this.imagen = null;
      this.$store.commit("setLangSeleccionadoDefecto");
    },
    addCaracteristica() {
      let caracteristica = {
        descripcion: this.descripcionIdiomas,
        nombre: this.nombreIdiomas,
        grupo: this.grupo,
        imagen: this.imagen,
        id: this.id ? this.id : null,
      };
      return this.$store.dispatch(
        "caracteristicas/addCaracteristica",
        caracteristica
      );
    },
    save() {
      let _vm = this;
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.loadingForm = true;
        if (this.isAdd || this.isEdit) {
          this.addCaracteristica()
            .then((res) => {
              _vm.$store.commit("snackbar/setMensajeSuccess", {
                msj: "Característica grabada con éxito",
              });
              _vm.getCaracteristicas();
              _vm.dialog = false;
            })
            .catch((error) => {
              console.log(error);
              _vm.$store.commit("snackbar/setMensajeDanger", {
                msj: "Error al guardar la característica",
              });
            })
            .finally(() => {
              _vm.loadingForm = false;
            });
        }
      }
    },
  },
  beforeMount() {
    let a_nombre = [];
    let a_descripcion = [];
    for (var lang of this.idiomas) {
      let aux_1 = { lang: lang.value, text: "" };
      let aux_2 = { lang: lang.value, text: "" };
      a_nombre.push(aux_1);
      a_descripcion.push(aux_2);
    }
    this.nombreIdiomas = a_nombre;
    this.descripcionIdiomas = a_descripcion;
  },
  mounted() {
    this.caracteristicasFiltrando = this.gruposCaracteristicas[0].value;
  },
};
</script>

<style>
</style>